import { render, staticRenderFns } from "./properties-page.vue?vue&type=template&id=5baee4fc&scoped=true"
import script from "./properties-page.vue?vue&type=script&lang=js"
export * from "./properties-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5baee4fc",
  null
  
)

export default component.exports